/**
 * Handle Quickshop Modal - when a user clicks to view the modal contents,
 * this will populate a single modal with all of the product data.
 */

import changeOptions, { handleDefaultOption } from "../product/change-options";
import selectWithSelectric from "../modules/select-with-selectric";
import handleBadge from "../modules/handleBadge";
import productSliders, { zoomBehaviour } from "../sliders/product-slider";
import {
  handleAddWishlist,
  handleDefaultVariant,
  handleWishlist,
} from "../product/change-variant";

export const triggerQuickShopModal = (productHandle, variantId) => {
  selectWithSelectric();
  const product_handle = productHandle;

  $("#quickshop").addClass("is-open");
  $.ajax({
    method: "get",
    url: `/products/${product_handle}${
      variantId ? "?variant=" + variantId : ""
    }`,
  }).done((response) => {
    $("body").addClass("no-scroll");
    const content = $(response).find(".section-product").children();
    $("#quickshop-loading").remove();
    $("#quickshop .section-product").removeClass("section-product--hidden");
    $("#quickshop .section-product").html(content);
    $("#quickshop .section-product")
      .find(".product__accordions")
      .replaceWith(
        `<a class="quickshop__link" id="quickshop-link" href='/products/${product_handle}${
          variantId ? "?variant=" + variantId : ""
        }'>View full product details</a>`
      );

    const colour = $(`input[id$='${variantId}']`).val();
    const optionTwo = $("#quickshop .list-radio-buttons")
      .first()
      .find(".selected-option")
      .val();

    productSliders(true, true, colour, true, optionTwo, variantId);

    handleDefaultOption(variantId);
    handleDefaultVariant(variantId);

    // Remove additional fields
    $("#quickshop .js-recommended-products").remove();
    $("#quickshop .product__wallpaper-cta").remove();
    changeOptions();

    handleWishlist();
    handleAddWishlist();

    if (!window.location.pathname.includes("/collections/")) {
      zoomBehaviour();
    }

    if ($("#quickshop .js-product-badge").length > 0) {
      handleBadge("#quickshop .js-product-badge");
    }
    $("#quickshop .form__foot").addClass("js-is-quickshop");
  });
};

export const handleQuickshopModal = () => {
  const $modalTrigger = ".js-modal-quickshop";

  $(document).on("click", $modalTrigger, function (event) {
    event.preventDefault();
    triggerQuickShopModal(
      $(this).data("productHandle"),
      $(this).data("variantId")
    );
  });
};

$(window);
handleQuickshopModal();
